import { NodeType } from '@amplify/amp-module';

export const MAX_PROJECT_NAME_LENGTH = 20;
export const MAX_CONVERSATION_NAME_LENGTH = 40;
export const RECENTLY_VIEWED_LENGTH = 4;
export const DEFAULT_CONVERSATION_NAME = 'Add your title';

export const DEFAULT_AMP_DTO = {
  ampType: 'website',
  color: 'rgba(98, 0, 234, 1)',
  name: '',
  icon: 'chatbubble_op1',
  avatarFile: null,
  error: '',
};

export const DEFAULT_AMP = {
  ampType: 'website',
  color: 'rgba(98, 0, 234, 1)',
  name: '',
  icon: 'chatbubble_op1',
  data: {
    conversations: {},
    storage: {},
  },
};

export const DEFAULT_WIZZARD_FILE = {
  name: '',
  size: 0,
  type: '',
  lastModified: 0,
};

export const DEFAULT_UPLOAD_STEP = {
  name: '',
  stepIndex: 0,
  steps: 1,
};

export const DEFAULT_WIZZARD_ERROR = {
  id: null,
  errors: [],
};

export const DEFAULT_COMMON_TRIGGERS = {
  onButtonClick: false,
  onElementInView: false,
  onScrollDepth: false,
};

export const GROUP_NODE_PORT_GROUPS = {
  out: {
    position: {
      name: 'bottom',
    },
    attrs: {
      circle: {
        r: 0,
        stroke: 'transparent',
      },
    },
  },
};

export const CONDITION_NODE_PORT_GROUPS = {
  condition: {
    position: {
      name: 'bottom',
    },
    attrs: {
      circle: {
        r: 0,
        stroke: 'transparent',
      },
    },
  },
};

export const AMP_ACTIONS_MENU = [
  {
    name: 'settings',
    text: 'Settings',
    icon: 'settings',
  },
  {
    name: 'insights',
    text: 'Insights',
    icon: 'whereused',
  },
  {
    name: 'share',
    text: 'Share',
    icon: 'share',
  },
  {
    name: 'delete',
    text: 'Delete',
    icon: 'delete',
  },
];

export const AMP_SORT_BY_OPTIONS = [
  {
    key: 'updatedAt',
    text: 'Last modified',
    order: 'desc',
  },
  {
    key: 'createdAt',
    text: 'Date created',
    order: 'desc',
  },
  {
    key: 'name',
    text: 'Alphabetical',
    order: 'asc',
  },
];

export const TOOLBAR_TOOLS = [
  {
    name: NodeType.message,
    text: 'Message',
    nodeLabel: 'Message',
    icon: 'message',
    draggable: true,
  },
  {
    name: NodeType.question,
    text: 'Question',
    nodeLabel: 'Question',
    icon: 'questionmark',
    draggable: true,
    lastTool: true,
  },
  {
    name: NodeType.buttonGroup,
    text: 'Button',
    nodeLabel: 'Buttons',
    subNodeLabel: 'Button',
    icon: 'button',
    draggable: true,
  },
  {
    name: NodeType.carousel,
    text: 'Card',
    nodeLabel: 'Cards',
    subNodeLabel: 'Card',
    icon: 'card',
    draggable: true,
  },
  {
    name: NodeType.player,
    text: 'Player',
    nodeLabel: 'Player',
    icon: 'player',
    draggable: true,
  },
  {
    name: NodeType.goTo,
    text: 'Go to',
    nodeLabel: 'Go to',
    icon: 'link',
    draggable: true,
  },
  {
    name: NodeType.open,
    text: 'Open',
    nodeLabel: 'Open',
    icon: 'sendto',
    draggable: true,
  },
  {
    name: NodeType.condition,
    text: 'Condition',
    nodeLabel: 'Condition',
    icon: 'condition',
    draggable: true,
  },
];

export const PLUGIN_TOOL = {
  name: NodeType.plugin,
  text: 'Plugin',
  nodeLabel: 'Plugin',
  icon: 'plugin',
};

export const AMP_SCRIPTS = {
  CustomScript: 'customScript',
};

export const DEMO_CHATBOT_STACK = [
  {
    node: {
      html: '<p>Hello James 👋</p><p>I’m the Remy Bot. I can help you with questions about topics and its treatment.</p>',
      id: 'message-1',
      type: 'message',
    },
  },
  {
    node: {
      subNodes: {
        'button-1': {
          id: 'button-1',
          buttonTexts: ['Button clicked'],
          sortIndex: 0,
        },
      },
      id: 'buttonGroup-1',
      type: 'buttonGroup',
      parentId: 'message-1',
    },
    selectedButtonId: 'button-1-0',
  },
  {
    node: {
      subNodes: {
        'button-2': {
          id: 'button-2',
          buttonTexts: ['Button 1', 'Button 2'],
        },
      },
      id: 'buttonGroup-2',
      type: 'buttonGroup',
      parentId: 'buttonGroup-1_port_button-1',
    },
  },
];
